shadow$provide[335] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Atlas:{enumerable:true, get:function() {
  return Atlas;
}}});
var UGLSL = require("../../util/glsl.js");
var require$_DOT__SLASH_texture_SLASH_backedtexture_DOT_js = require("./texture/backedtexture.js");
var require$_DOT__SLASH_texture_SLASH_datatexture_DOT_js = require("./texture/datatexture.js");
var require$_DOT__DOT__SLASH_renderable_DOT_js = require("../renderable.js");
var require$three = require("three");
class Atlas extends require$_DOT__DOT__SLASH_renderable_DOT_js.Renderable {
  constructor(renderer, shaders, options, build) {
    if (build == null) {
      build = true;
    }
    super(renderer, shaders);
    if (this.width == null) {
      this.width = options.width || 512;
    }
    if (this.height == null) {
      this.height = options.height || 512;
    }
    if (this.channels == null) {
      this.channels = options.channels || 4;
    }
    if (this.backed == null) {
      this.backed = options.backed || false;
    }
    this.samples = this.width * this.height;
    if (build) {
      this.build(options);
    }
  }
  shader(shader) {
    shader.pipe("map.2d.data", this.uniforms);
    shader.pipe("sample.2d", this.uniforms);
    if (this.channels < 4) {
      shader.pipe(UGLSL.swizzleVec4(["0000", "x000", "xw00", "xyz0"][this.channels]));
    }
    return shader;
  }
  build(options) {
    let klass;
    this.klass = klass = this.backed ? require$_DOT__SLASH_texture_SLASH_backedtexture_DOT_js.BackedTexture : require$_DOT__SLASH_texture_SLASH_datatexture_DOT_js.DataTexture;
    this.texture = new klass(this.renderer, this.width, this.height, this.channels, options);
    this.uniforms = {dataPointer:{type:"v2", value:new require$three.Vector2(0, 0),},};
    this._adopt(this.texture.uniforms);
    return this.reset();
  }
  reset() {
    this.rows = [];
    return this.bottom = 0;
  }
  resize(width, height) {
    if (!this.backed) {
      throw new Error("Cannot resize unbacked texture atlas");
    }
    if (width > 2048 && height > 2048) {
      console.warn(`Giant text atlas ${width}x${height}.`);
    } else {
      console.info(`Resizing text atlas ${width}x${height}.`);
    }
    this.texture.resize(width, height);
    this.width = width;
    this.height = height;
    return this.samples = width * height;
  }
  collapse(row) {
    let left;
    const {rows} = this;
    rows.splice(rows.indexOf(row), 1);
    this.bottom = (left = __guard__(rows[rows.length - 1], x => x.bottom)) != null ? left : 0;
    if (this.last === row) {
      return this.last = null;
    }
  }
  allocate(key, width, height, emit) {
    const w = this.width;
    const h = this.height;
    const max = height * 2;
    if (width > w) {
      this.resize(w * 2, h * 2);
      this.last = null;
      return this.allocate(key, width, height, emit);
    }
    let row = this.last;
    if (row != null) {
      if (row.height >= height && row.height < max && row.width + width <= w) {
        row.append(key, width, height, emit);
        return;
      }
    }
    let bottom = 0;
    let index = -1;
    let top = 0;
    for (let i = 0; i < this.rows.length; i++) {
      row = this.rows[i];
      const gap = row.top - bottom;
      if (gap >= height && index < 0) {
        index = i;
        top = bottom;
      }
      ({bottom} = row);
      if (row.height >= height && row.height < max && row.width + width <= w) {
        row.append(key, width, height, emit);
        this.last = row;
        return;
      }
    }
    if (index >= 0) {
      row = new Row(top, height);
      this.rows.splice(index, 0, row);
    } else {
      top = bottom;
      bottom += height;
      if (bottom >= h) {
        this.resize(w * 2, h * 2);
        this.last = null;
        return this.allocate(key, width, height, emit);
      }
      row = new Row(top, height);
      this.rows.push(row);
      this.bottom = bottom;
    }
    row.append(key, width, height, emit);
    this.last = row;
  }
  read() {
    return this.texture.textureObject;
  }
  write(data, x, y, w, h) {
    return this.texture.write(data, x, y, w, h);
  }
  dispose() {
    this.texture.dispose();
    this.data = null;
    return super.dispose();
  }
}
class Row {
  constructor(top, height) {
    this.top = top;
    this.bottom = top + height;
    this.width = 0;
    this.height = height;
    this.alive = 0;
    this.keys = [];
  }
  append(key, width, height, emit) {
    const x = this.width;
    const y = this.top;
    this.alive++;
    this.width += width;
    this.keys.push(key);
    return emit(this, x, y);
  }
}
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};